
import React from "react";
import BrandGroup from "./SeriesGroup";
import { getSegmentIcon } from "@/utils/pdfDataUtils";
import { formatCurrency } from "@/lib/formatters";

interface GroupedProduct {
  id: number;
  nome: string;
  marca: string;
  brand_id: number;
  precoAluno2025: number;
  valorUnitario: number;
  qtdReferencia: number;
  quantidade: number;
  valorTotal: number;
}

interface BrandGroup {
  nome: string;
  brandId: number;
  produtos: GroupedProduct[];
  total: number;
  somaPrecoAluno2025: number;
  somaPrecoAluno2026: number;
}

interface SegmentSectionProps {
  nome: string;
  brands: BrandGroup[];
  total: number;
  isCompactMode?: boolean;
}

const SegmentSection = ({
  nome,
  brands,
  total,
  isCompactMode = false
}: SegmentSectionProps) => {
  const icon = getSegmentIcon(nome);

  return (
    <div className="h-full flex flex-col">
      {/* Segment Header */}
      <div className={`bg-blue-600 text-white rounded-lg p-${isCompactMode ? '4' : '6'} mb-4 shadow-sm flex-shrink-0`}>
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3">
            <span className={`text-${isCompactMode ? '2xl' : '3xl'}`}>{icon}</span>
            <div>
              <h3 className={`text-${isCompactMode ? 'xl' : '2xl'} font-bold`}>{nome}</h3>
              <div className="text-blue-100 text-xs mt-1">
                {brands.length} {brands.length === 1 ? 'marca' : 'marcas'}
              </div>
            </div>
          </div>
          <div className="text-right">
            <div className="text-blue-100 text-xs mb-1">Total do Segmento</div>
            <div className={`text-${isCompactMode ? '2xl' : '3xl'} font-bold`}>
              {formatCurrency(total)}
            </div>
          </div>
        </div>
      </div>

      {/* Brand Groups - Scrollable area */}
      <div className={`flex-1 overflow-auto space-y-${isCompactMode ? '3' : '6'}`}>
        {brands.map((brand, index) => (
            <BrandGroup
              key={`${nome}-${brand.nome}-${index}`}
              nome={brand.nome}
              produtos={brand.produtos}
              total={brand.total}
              somaPrecoAluno2025={brand.somaPrecoAluno2025}
              somaPrecoAluno2026={brand.somaPrecoAluno2026}
              isCompactMode={isCompactMode}
            />
        ))}
      </div>
    </div>
  );
};

export default SegmentSection;
